import DemoVideoAlert from './DemoVideoAlert'
export default DemoVideoAlert
